import { DISTRIBUTOR, DOMAIN } from '@autopass-web/domain';
import { Interceptor, UserHttpClient } from '@autopass-web/mochi-web-api';
import get from 'lodash/get';
import { storage } from '../app-loader';

class HeaderConfigInterceptor extends Interceptor {
  onIntercept = (request) => {
    const accessToken = () => {
      const accessToken = get(storage.getAuth(), 'accessToken', undefined);
      return accessToken ? `Bearer ${accessToken}` : '';
    };

    const token = accessToken();
    if (token) request.headers['Authorization'] = token;
    request.headers['Mochipay-Client-Id'] =
      DOMAIN.DISTRIBUTOR_CLIENT_UID[
        process.env.NEXT_PUBLIC_DISTRIBUTOR || DISTRIBUTOR.AUTOPASS
      ];
    return request;
  };
}

const http = new UserHttpClient({
  requestInterceptorChain: [new HeaderConfigInterceptor()],
  responseResultInterceptorChain: [],
  responseErrorInterceptorChain: [],
});

class Repository {
  fetchUserInfo = async () => {
    const { error, data } = await http.fetchUser();
    return { error, data: data?.data.data };
  };

  fetchPaymentToken = async (plateNumber) => {
    const { error, data } = await http.fetchPaymentToken(plateNumber);
    return { error, data: data?.data.data };
  };

  fetchBarcodePaymentPopupBoard = async () => {
    const codes = 'barcode_payment_popup_board';
    const { error, data } = await http.boards({ codes });
    return { error, data: data?.data.data.barcodePaymentPopupBoard };
  };

  fetchBarcodePaymentHintBoard = async () => {
    const codes = 'barcode_payment_hint_board';
    const { error, data } = await http.boards({ codes });
    return { error, data: data?.data.data.barcodePaymentHintBoard };
  };
}

export default Repository;
